<template>
    <div
        class="p-0 game-card"
        @click="$emit('click', game)"
    >
        <div class="flex flex-col gap-2 justify-center">
            <div class="w-full h-[158px]">
                <div class="w-full h-full rounded-[38px] relative">
                    <img
                        :src="game.image_url"
                        :alt="game.gameName"
                        class="w-full h-full rounded-[38px] object-fill"
                    />
                    <img
                        src="https://www.burma368.net/static/image/home/game-item-border-image.png"
                        class="absolute top-0 left-0 w-full h-full"
                        alt="border"
                    />
                    <img
                        src="https://www.burma368.net/static/image/home/game-item-play.png"
                        class="w-[60px] h-[60px] absolute bottom-0 right-0"
                        alt="play"
                    />
                </div>
            </div>

            <p class="!text-[12px] m-0 text-white font-medium text-center truncate">
                {{ game.gameName }}
            </p>
        </div>
    </div>
</template>

<script>
export default {
    name: "GameCard",
    props: {
        game: { type: Object, required: true },
    },
};
</script>

<style scoped>
.game-card {
    cursor: pointer;
    transition: transform 0.2s ease, box-shadow 0.2s ease;
    background: transparent;
    border-radius: 10px;
    height: auto;
}

.game-card:hover {
    transform: scale(1.03);
}
</style>
